export const inventoryFilterKeys = [
  'q',
  'country_code',
  'geo_place_id',
  'destination_label',
  'status',
  'connector',
  'connector_account_id',
  'access_code',
  'supplier_code',
  'supplier_hotel_code',
  'has_connection',
  'has_fastx',
  'published',
] as const;
export type InventoryFilters = Record<(typeof inventoryFilterKeys)[number], string>;
export function inventoryState(params: URLSearchParams): InventoryFilters {
  return Object.fromEntries(inventoryFilterKeys.map((k) => [k, params.get(k) ?? ''])) as InventoryFilters;
}
export function inventoryOffset(params: URLSearchParams) {
  const raw = params.get('offset') ?? '0';
  return /^\d+$/.test(raw) && Number(raw) <= 10000000 ? Number(raw) : 0;
}
export function inventoryParams(filters: InventoryFilters, offset = 0) {
  const params = new URLSearchParams();
  for (const k of inventoryFilterKeys) if (filters[k].trim()) params.set(k, filters[k].trim());
  if (offset) params.set('offset', String(offset));
  return params;
}
export function inventoryRequest(filters: InventoryFilters, offset: number) {
  const params = inventoryParams(filters, offset);
  params.delete('destination_label');
  params.set('offset', String(offset));
  params.set('limit', '25');
  return Object.fromEntries(params);
}
export interface InventoryConnection {
  connector: 'hotelbeds' | 'travelgate';
  connector_account_id: string;
  account_name: string;
  account_status: 'active' | 'disabled';
  access_code: string | null;
  supplier_code: string | null;
  provider_code: string | null;
  hotel_code: string;
  native_hotel_code: string | null;
}
export interface InventoryHotel {
  hotel_id: string;
  display_name: string;
  country_code: string | null;
  locality: string | null;
  status: 'active' | 'inactive';
  catalog_status: 'active' | 'draft' | 'archived' | null;
  published: boolean;
  has_location: boolean;
  main_image: string | null;
  connections: InventoryConnection[];
  connections_count: number;
  fastx_codes: string[];
}
export interface InventoryPage {
  data: InventoryHotel[];
  meta: { count: number; limit: number; offset: number; has_more: boolean };
}
export interface InventoryOptions {
  data: {
    country_codes: string[];
    connections: Array<{
      connector_account_id: string;
      display_name: string;
      connector: 'hotelbeds' | 'travelgate';
      status: 'active' | 'disabled';
      access_codes: string[];
    }>;
  };
}
